import "react-toastify/dist/ReactToastify.css";
import "./app.scss";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "./layouts/AdminLayout";
import PublicLayout from "./layouts/PublicLayout";
import HomePage from "./pages/Home/HomePage";
import SignupPage from "./pages/User/SignupPage";
import ListGrievancesPage from "./pages/Grievance/ListGrievancesPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import UsersPage from "./pages/User/UsersPage";
import NotFoudPage from "./pages/404/NotFoudPage";
import ManageGrievancePage from "./pages/Grievance/ManageGrievancePage";
import CreateUserPage from "./pages/User/CreateUserPage";
import UserProfilePage from "./pages/User/UserProfilePage";
import ContractsPage from "./pages/Contract/ContractsPage";
import CreateContractPage from "./pages/Contract/CreateContractPage";
import CreateBusinessPlanPage from "./pages/BusinessPlan/CreateBusinessPlanPage";
import BusinessPlansPage from "./pages/BusinessPlan/BusinessPlansPage";
import ApplicationEvaluationPage from "./pages/Application/ApplicationEvaluationPage";
import ApplicationRankingPage from "./pages/Application/ApplicationRankingPage";
import ApplicationJuryPanelPage from "./pages/Application/ApplicationJuryPanelPage";
import ApplicationTriagePage from "./pages/Application/ApplicationTriagePage";
import ViewApplicationPage from "./pages/Application/ViewApplicationPage";
import ApplicationValidationPage from "./pages/Application/ApplicationValidationPage";
import SubmitGrievancePage from "./pages/Grievance/SubmitGrievancePage";
import UpdateUserPage from "./pages/User/UpdateUserPage";
import CompetitorDashboardPage from "./pages/Dashboard/CompetitorDashboardPage";
import AddApplicationPage from "./pages/Application/AddApplicationPage";
import { AuthProvider } from "./contexts/AuthContext";
import EditApplicationPage from "./pages/Application/EditApplicationPage";
import ListApplicationsPage from "./pages/Application/ListApplicationsPage";
import TrackGrievancePage from "./pages/Grievance/TrackGrievancePage";
import ViewGrievancePage from "./pages/Grievance/ViewGrievancePage";
import ScoreApplicationPage from "./pages/Application/ScoreApplicationPage";
import LoginPage from "./pages/Home/LoginPage";
import ApplicationTiebreakerPage from "./pages/Application/ApplicationTiebreakerPage";
import JuryApplicationPage from "./pages/Application/JuryApplicationSammaryPage copy";
import UpdateBusinessPlanPage from "./pages/BusinessPlan/UpdateBusinessPlanPage";
import ViewBusinessPlanPage from "./pages/BusinessPlan/ViewBusinessPlanPage";
import ListBusinessPlansPage from "./pages/BusinessPlan/ListBusinessPlansPage";
import BusinessPlanJuryPanelPage from "./pages/BusinessPlan/BusinessPlanJuryPanelPage";
import BusinessPlanEvaluationPage from "./pages/BusinessPlan/BusinessPlanEvaluationPage";
import JuryBusinessPlanPage from "./pages/BusinessPlan/JuryBusinessPlanPage";
import ScoreBusinessPlanPage from "./pages/BusinessPlan/ScoreBusinessPlanPage";
import BusinessPlanRankingPage from "./pages/BusinessPlan/BusinessPlanRankingPage";
import ListVacanciesPage from "./pages/Internship/ListVacanciesPage";
import CreateVacancyPage from "./pages/Internship/CreateVacancyPage";
import UpdateVacancyPage from "./pages/Internship/UpdateVacancyPage";
import TraineeProfilePage from "./pages/Internship/TraineeProfilePage";
import TraineeDashboardPage from "./pages/Dashboard/TraineeDashboardPage";
import ListInternshipApplicationsPage from "./pages/Internship/ListInternshipApplicationsPage";
import TraineeProfileSummaryPage from "./pages/Internship/TraineeProfileSummaryPage";
import ScoreTraineePage from "./pages/Internship/ScoreTraineePage";
import TraineeRankingPage from "./pages/Internship/TraineeRankingPage";

function App() {
  return (
    <>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicLayout />}>
            <Route path="/" element={<HomePage />}></Route>
            <Route path="adm" element={<LoginPage />} />
            <Route path="regista-te" element={<SignupPage />} />
            <Route path="reclamacoes" element={<SubmitGrievancePage />} />
            <Route
              path="verificar-reclamacao/:occurrenceNumber"
              element={<TrackGrievancePage />}
            />
          </Route>
          <Route path="/admin/*" element={<AdminLayout />}>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="candidaturas" element={<ListApplicationsPage />} />
            <Route path="inicio" element={<CompetitorDashboardPage />} />
            <Route
              path="painel-estagiario"
              element={<TraineeDashboardPage />}
            />
            <Route path="perfil-estagiario" element={<TraineeProfilePage />} />
            <Route
              path="registar-candidatura"
              element={<AddApplicationPage />}
            />
            <Route
              path="editar-candidatura/:uuid"
              element={<EditApplicationPage />}
            />
            <Route path="candidatura/:uuid" element={<ViewApplicationPage />} />
            <Route
              path="candidatura-juri/:uuid"
              element={<JuryApplicationPage />}
            />
            <Route
              path="triagem-de-candidaturas"
              element={<ApplicationTriagePage />}
            />
            <Route
              path="painel-de-juri"
              element={<ApplicationJuryPanelPage />}
            />
            <Route
              path="avaliacao-de-candidaturas"
              element={<ApplicationEvaluationPage />}
            />
            <Route
              path="pontuar-candidatura/:uuid"
              element={<ScoreApplicationPage />}
            />
            <Route
              path="ranking-de-candidaturas"
              element={<ApplicationRankingPage />}
            />
            <Route
              path="desempate-de-pontuacao"
              element={<ApplicationTiebreakerPage />}
            />
            <Route
              path="validacao-de-candidaturas"
              element={<ApplicationValidationPage />}
            />
            <Route
              path="planos-de-negocio"
              element={<ListBusinessPlansPage />}
            />
            <Route
              path="registar-plano-de-negocio"
              element={<CreateBusinessPlanPage />}
            />
            <Route
              path="editar-plano-de-negocio/:uuid"
              element={<UpdateBusinessPlanPage />}
            />
            <Route
              path="plano-de-negocio/:uuid"
              element={<ViewBusinessPlanPage />}
            />
            <Route
              path="painel-de-juri-planos-de-negocio"
              element={<BusinessPlanJuryPanelPage />}
            />
            <Route
              path="planos-de-negocio-do-juri"
              element={<BusinessPlanEvaluationPage />}
            />
            <Route
              path="plano-de-negocio-juri/:uuid"
              element={<JuryBusinessPlanPage />}
            />
            <Route
              path="pontuar-plano-de-negocio/:uuid"
              element={<ScoreBusinessPlanPage />}
            />
            <Route
              path="ranking-de-planos-de-negocio"
              element={<BusinessPlanRankingPage />}
            />
            <Route path="vagas-para-estagio" element={<ListVacanciesPage />} />
            <Route path="registar-vaga" element={<CreateVacancyPage />} />
            <Route
              path="vagas-para-estagio/:uuid"
              element={<UpdateVacancyPage />}
            />
            <Route
              path="candidaturas-para-estagio"
              element={<ListInternshipApplicationsPage />}
            />
            <Route
              path="candidaturas-para-estagio/:id"
              element={<TraineeProfileSummaryPage />}
            />
            <Route
              path="pontuar-estagiario/:id"
              element={<ScoreTraineePage />}
            />
            <Route
              path="ranking-candidatos-para-estagio"
              element={<TraineeRankingPage />}
            />

            <Route path="contratos" element={<ContractsPage />} />
            <Route path="registar-contrato" element={<CreateContractPage />} />
            <Route path="reclamacoes" element={<ListGrievancesPage />} />
            <Route
              path="consultar-reclamacao/:occurrenceNumber"
              element={<ViewGrievancePage />}
            />
            <Route
              path="gerir-reclamacoes/:occurrenceNumber"
              element={<ManageGrievancePage />}
            />
            <Route path="utilizadores" element={<UsersPage />} />
            <Route path="registar-utilizador" element={<CreateUserPage />} />
            <Route
              path="actualizar-utilizador/:username"
              element={<UpdateUserPage />}
            />
            <Route path="minha-conta" element={<UserProfilePage />} />
          </Route>
          <Route path="*" element={<NotFoudPage />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App;
